module.exports = __webpack_public_path__ + "img/Purple.aaf2e601.png";